import React, { useRef, useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import axios from 'axios';
import { API } from '../api';
import { partners as fallbackPartners } from '../mock';

const Partners = () => {
  const ref = useRef(null);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sectionTitle, setSectionTitle] = useState('Our Trusted Hotel Partners');

  useEffect(() => {
    axios.get(`${API}/partners`)
      .then((res) => {
        if (Array.isArray(res.data) && res.data.length > 0) {
          setItems(res.data);
        } else {
          setItems(fallbackPartners.map((name, i) => ({ id: `mock-${i}`, name, logo: '', order: i })));
        }
      })
      .catch(() => {
        setItems(fallbackPartners.map((name, i) => ({ id: `mock-${i}`, name, logo: '', order: i })));
      })
      .finally(() => setLoading(false));

    axios.get(`${API}/site-settings`)
      .then((res) => {
        if (res.data?.section_partners_title) setSectionTitle(res.data.section_partners_title);
      })
      .catch(() => {});
  }, []);

  const scroll = (dir) => {
    if (!ref.current) return;
    ref.current.scrollBy({ left: dir * 240, behavior: 'smooth' });
  };

  if (loading || items.length === 0) {
    return (
      <section className="py-12 bg-white border-y border-gray-100">
        <div className="max-w-[1280px] mx-auto px-5 lg:px-8">
          <h3 className="text-center text-sm uppercase tracking-widest text-gray-500 mb-6">{sectionTitle}</h3>
          {loading && <div className="text-center text-xs text-gray-400">Loading partners...</div>}
        </div>
      </section>
    );
  }

  return (
    <section className="py-12 bg-white border-y border-gray-100">
      <div className="max-w-[1280px] mx-auto px-5 lg:px-8">
        <h3 className="text-center text-sm uppercase tracking-widest text-gray-500 mb-6">{sectionTitle}</h3>
        <div className="relative">
          <button
            onClick={() => scroll(-1)}
            className="absolute -left-4 top-1/2 -translate-y-1/2 z-10 w-9 h-9 rounded-full bg-white border border-gray-200 text-[#0d64a8] flex items-center justify-center shadow hover:bg-[#0d64a8] hover:text-white transition"
            aria-label="prev"
          >
            <ChevronLeft size={18} />
          </button>
          <button
            onClick={() => scroll(1)}
            className="absolute -right-4 top-1/2 -translate-y-1/2 z-10 w-9 h-9 rounded-full bg-white border border-gray-200 text-[#0d64a8] flex items-center justify-center shadow hover:bg-[#0d64a8] hover:text-white transition"
            aria-label="next"
          >
            <ChevronRight size={18} />
          </button>

          <div ref={ref} className="flex gap-6 overflow-x-auto scroll-smooth pb-2 items-center" style={{ scrollbarWidth: 'none' }}>
            {items.map((p) => (
              <div
                key={p.id || p.name}
                className="shrink-0 w-40 h-24 flex items-center justify-center border border-gray-100 rounded-lg bg-gray-50 hover:bg-white hover:shadow-md transition p-3"
                title={p.name}
              >
                {p.logo ? (
                  <img
                    src={p.logo}
                    alt={p.name}
                    className="max-h-full max-w-full object-contain"
                    onError={(e) => {
                      // fall back to name if logo fails
                      e.currentTarget.style.display = 'none';
                      const sib = e.currentTarget.nextSibling;
                      if (sib) sib.style.display = 'inline';
                    }}
                  />
                ) : null}
                <span className={`text-lg font-semibold text-gray-500 tracking-wide ${p.logo ? 'hidden' : ''}`}>
                  {p.name}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Partners;
